import { useWatch } from "react-hook-form";
import { ResidentFormData } from "../../schemas/residentForm";
import { ResidentTypeSwitcher } from "./ResidentTypeSwitcher";
import { ResidentIndividualForm } from "./ResidentIndividualForm";
import { ResidentCompanyForm } from "./ResidentCompanyForm";

interface TenantFormContentProps {
  displayIndex: number;
  disabled?: boolean;
  isPpe?: boolean;
}

export const TenantFormContent: React.FC<TenantFormContentProps> = ({
  displayIndex,
  disabled = false,
  isPpe = false,
}) => {
  // Get all tenants sorted by tenant_index (same logic as getAllTenantsForDisplay in ResidentForm)
  const individualTenants = (useWatch<ResidentFormData>({ name: "individual_tenants" }) ||
    []) as ResidentFormData["individual_tenants"];
  const enterpriseTenants = (useWatch<ResidentFormData>({ name: "enterprise_tenants" }) ||
    []) as ResidentFormData["enterprise_tenants"];

  const individual = individualTenants.map((t, idx) => ({
    ...t,
    tenant_index: t.tenant_index ?? idx,
    _type: "particulier" as const,
    _arrayIndex: idx,
  }));
  const enterprise = enterpriseTenants.map((t, idx) => ({
    ...t,
    tenant_index: t.tenant_index ?? individual.length + idx,
    _type: "entreprise" as const,
    _arrayIndex: idx,
  }));
  const allTenantsSorted = [...individual, ...enterprise].sort(
    (a, b) => (a.tenant_index ?? 0) - (b.tenant_index ?? 0)
  );

  const tenant = allTenantsSorted[displayIndex];
  const tenantType = tenant?._type || "particulier";
  const arrayIndex = tenant?._arrayIndex ?? 0;

  return (
    <>
      <ResidentTypeSwitcher displayIndex={displayIndex} disabled={disabled} />
      {tenantType === "particulier" ? (
        <ResidentIndividualForm arrayIndex={arrayIndex} disabled={disabled} isPpe={isPpe} />
      ) : (
        <ResidentCompanyForm arrayIndex={arrayIndex} disabled={disabled} />
      )}
    </>
  );
};
